import {InjectionToken} from '@angular/core';

export const CURRENT_ORG_ID: InjectionToken<number> = new InjectionToken<number>('currentOrgId', {
  providedIn: 'root',
  factory: () => {
    const match = window.location.pathname.match(/\/(?:organization:|org\/)(\d+)/);
    return match ? parseInt(match[1], 10) : undefined;
  },
});
